<template>
    <mu-circular-progress :size="40"/>
</template>
<script>
export default {
    name: 'circularProgress'
}
</script>



// WEBPACK FOOTER //
// circularProgress.vue?ee433216